<template>
  <div class="content">
    <div class="iconWrapper">
      <i class="icon bi bi-check" />
    </div>
    <div class="title">Votre aventure vous attend !</div>
    <div class="subtitle">Vous disposez de 10 minutes pour commencer à jouer en cliquant sur le bouton ci-dessous. Passé
      ce délai, vous devrez relancer une session.</div>
    <div class="textBox">
      <div class="iconWrapper2">
        <i class="icon bi bi-exclamation" />
      </div>
      <div class="text">En fonction de la stabilité de votre connexion Internet, de légers ralentissements pourraient
        survenir lors de votre expérience. Rassurez-vous, ces éventuels désagréments n’auront pas d’influence sur vos
        résultats.
      </div>
    </div>
    <Button class="primary" label="Commencer à jouer !" @click="$emit('go')" />
  </div>
</template>

<style lang="scss" scoped>
.content {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;

  .iconWrapper {
    width: 64px;
    height: 64px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    font-size: 36px;

    background-color: #1FA969;
  }

  .title {
    font-size: 32px;
    font-weight: 700;

    margin: 8px 0;
  }

  .subtitle {
    font-size: 18px;
    text-align: center;
  }

  .textBox {
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 16px;

    margin: 40px 0;

    border-radius: 6px;
    border: 1px solid #F2CB36;
    background: #2D2A27;

    .iconWrapper2 {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      border: 2px solid #F2CB36;

      font-size: 24px;
    }

    .text {
      font-size: 16px;
    }
  }

}
</style>

<script setup lang="ts">
</script>